<template>
	<DetailTemplate :activeIndexNum="activeIndex" :showSublings="false" :showRelated="false" :map="true">
	</DetailTemplate>
</template>

<script>
	import DetailTemplate from "~/components/template/DetailTemplate.vue";
	export default {
		components: {
			DetailTemplate
		},
		data() {
			return {
				activeIndex: '0',
			}
		},
		mounted: function() {
			const activeIndex = this.$route.query.activeIndex;
			this.activeIndex = activeIndex + '';
		},
	}
</script>


// WEBPACK FOOTER //
// src/views/link/jingdian.vue